module.exports = __webpack_public_path__ + "img/admin_adv_05.5d253aec.png";